import { ResourceKey } from '../types/common.js';
export const RESOURCE_META = {
    wood: {
        key: ResourceKey.WOOD,
        displayName: 'Timber',
        shortName: 'Wood',
        icon: '🪵',
        description: 'Felled and seasoned in the timber camps. The bones of every building.',
        baseProduction: 30,
        growthFactor: 1.16,
    },
    clay: {
        key: ResourceKey.CLAY,
        displayName: 'Clay',
        shortName: 'Clay',
        icon: '🧱',
        description: 'Dug from the riverbanks and fired into brick for walls and kilns.',
        baseProduction: 30,
        growthFactor: 1.16,
    },
    iron: {
        key: ResourceKey.IRON,
        displayName: 'Iron',
        shortName: 'Iron',
        icon: '⛏️',
        description: 'Hauled out of the deep seams. Weapons, armour, and tools.',
        baseProduction: 25,
        growthFactor: 1.18,
    },
    grain: {
        key: ResourceKey.GRAIN,
        displayName: 'Grain',
        shortName: 'Grain',
        icon: '🌾',
        description: 'Feeds the village and every soldier in it. Run out and the queues stop.',
        baseProduction: 40,
        growthFactor: 1.12,
    },
};
/**
 * Barter rates used by the market, expressed in "wood-equivalents" per unit.
 * Derived from the GDD exchange table:
 *   wood:clay 1:1, wood:iron 1.5:1, clay:iron 1.2:1, grain:resources 2:1
 * Iron is the mean of the two stated iron rates (1.5 and 1.2) to keep the
 * table internally consistent - a single value cannot satisfy both exactly.
 */
export const RESOURCE_BARTER_VALUE = {
    wood: 1.0,
    clay: 1.0,
    iron: 1.35,
    grain: 2.0,
};
/** How many units of `to` you receive for one unit of `from`. */
export function exchangeRate(from, to) {
    return RESOURCE_BARTER_VALUE[from] / RESOURCE_BARTER_VALUE[to];
}
//# sourceMappingURL=resources.js.map